// CSS Modules - component class name prefix: DownloadListTeaser__

<template>
  <div :class="$style.container">
    <div
      :class="[{ DownloadListTeaser__withImage: result.image }, $style.content]"
    >
      <div
        ref="expandableSubHeading"
        v-if="result.subHeading"
        :class="[$style.subHeading, $style.expandable]"
      >
        <span>{{ result.subHeading }}</span>
        <a
          v-if="hasMoreSubHeading"
          :class="[
            { DownloadListTeaser__open: expandedSubHeading },
            $style.more
          ]"
          @click="toggleExpandableSubHeading"
        ></a>
      </div>
      <div
        ref="expandableTypes"
        v-if="result.expandable"
        :class="[
          { DownloadListTeaser__entryTitle: !result.productcode },
          $style.expandable
        ]"
      >
        <div v-for="(elm, key) in result.expandable" :key="key">
          {{ key }}:
          <span
            v-for="(type, index) in elm"
            :key="index"
            :class="$style.type"
            >{{ type }}</span
          >
          <a
            v-if="hasMoreTypes"
            :class="[{ DownloadListTeaser__open: expandedTypes }, $style.more]"
            @click="toggleExpandableTypes"
          ></a>
        </div>
      </div>
      <h5 v-if="result.title" :class="$style.title" v-html="result.title"></h5>
      <div
        v-if="result.description"
        :class="$style.description"
        v-html="result.description"
      ></div>
      <div v-for="(elm, key) in result.text" :key="key" :class="$style.text">
        <div v-if="Array.isArray(elm)">
          {{ key }}:
          <span
            v-for="(type, index) in elm"
            :key="index"
            :class="$style.type"
            >{{ type }}</span
          >
        </div>
        <div v-else>{{ key }}: {{ elm }}</div>
      </div>
      <CountryDownloadBox
        v-if="result.files"
        :countries="result.files"
        :section="section"
        :title="result.title || result.subHeading || result.description"
        :types="result.productTypes"
        :labels="labels"
        :context="getContext()"
        :wtParams="mergeWtParams(wtParams, result.wtParams, result)"
      />
      <div v-if="result.software" :class="$style.software">
        <DownloadButton
          v-if="result.software.file"
          :labels="labels"
          :config="
            createConfigFromSoftwareResult(
              result.software.file,
              result.productTypes,
              result.description,
              false
            )
          "
          :section="section"
          :wtParams="{
            ...wtParams,
            ...result.software.file.wtParams
          }"
        />
        <DownloadButton
          v-if="result.software.manual"
          :labels="labels"
          colour="white"
          :config="
            createConfigFromSoftwareResult(
              result.software.manual,
              result.productTypes,
              result.description,
              true
            )
          "
          :section="section"
        />
      </div>
      <div v-if="result.link" :class="$style.data3d">
        <DownloadButton
          :labels="labels"
          :config="createConfigFrom3dDataResult(result)"
          :section="section"
          :wtParams="mergeWtParams(wtParams, result.wtParams, result)"
        />
      </div>
    </div>
    <div
      v-if="result.image"
      :class="$style.image"
      :style="{ backgroundImage: `url(${result.image})` }"
    >
      <img :src="result.image" />
    </div>
  </div>
</template>

<script>
import CountryDownloadBox from "../CountryDownloadBox/CountryDownloadBox";
import { CountryDownloadBoxContext } from "../../globals/constants/download";
import DownloadButton from "../DownloadButton/DownloadButton";
import { mergeSwitchWtParams } from "../../utils/tracking";

export default {
  name: "DownloadListTeaser",
  components: {
    DownloadButton,
    CountryDownloadBox
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    labels: {
      type: Object,
      default: () => {}
    },
    wtParams: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {
      hasMoreTypes: false,
      expandedTypes: false,
      hasMoreSubHeading: false,
      expandedSubHeading: false,
      section: ""
    };
  },
  methods: {
    mergeWtParams(globalWtParams, itemWtParams, itemParams) {
      return mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);
    },
    checkExpandable() {
      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
      const maxScrollheight = isIE11 ? 31 : 25;
      this.hasMoreTypes =
        this.$refs.expandableTypes &&
        this.$refs.expandableTypes.scrollHeight > maxScrollheight;
      this.hasMoreSubHeading =
        this.$refs.expandableSubHeading &&
        this.$refs.expandableSubHeading.scrollHeight > maxScrollheight;
    },
    toggleExpandableTypes() {
      this.$refs.expandableTypes.style.height = this.expandedTypes
        ? ""
        : "auto";
      this.expandedTypes = !this.expandedTypes;
    },
    toggleExpandableSubHeading() {
      this.$refs.expandableSubHeading.style.height = this.expandedSubHeading
        ? ""
        : "auto";
      this.expandedSubHeading = !this.expandedSubHeading;
    },
    getContext() {
      return CountryDownloadBoxContext.DOWNLOAD_LIST_TEASER;
    },
    createConfigFromSoftwareResult(
      downloadable,
      productTypes,
      description,
      isManual
    ) {
      return {
        labels: {
          wishlist: downloadable.text
        },
        metadata: {
          fileType: "",
          fileSize: ""
        },
        title: downloadable.text,
        wishlistTitle: isManual
          ? `${downloadable.text}: ${description}`
          : description,
        types: productTypes || [],
        urls: {
          file: "",
          language: "",
          url: downloadable.url
        }
      };
    },
    createConfigFrom3dDataResult(result) {
      return {
        labels: {
          wishlist: result.subHeading
        },
        metadata: {
          fileType: "",
          fileSize: ""
        },
        title: result.subHeading,
        wishlistTitle: result.description,
        types: result.productTypes || [],
        urls: {
          file: "",
          language: "",
          url: result.link
        }
      };
    }
  },
  mounted() {
    if (this.$refs.expandableTypes || this.$refs.expandableSubHeading) {
      window.addEventListener("resize", this.checkExpandable);
      this.checkExpandable();
    }
    if (window.downloadCategory) {
      this.section = window.downloadCategory;
    }
  },
  updated() {
    if (this.$refs.expandableTypes || this.$refs.expandableSubHeading) {
      this.checkExpandable();
    }
  },
  destroyed() {
    if (this.$refs.expandableTypes || this.$refs.expandableSubHeading) {
      window.removeEventListener("resize", this.checkExpandable);
    }
  }
};
</script>

<style module lang="scss">
@import "./DownloadListTeaser.scss";
</style>
